import { create } from "zustand"

export const useFocusMode = create(set => ({
  inFocusMode: false,
  toggle: () =>
    set(state => ({
      inFocusMode: !state.inFocusMode
    })),
  enter: () => set({ inFocusMode: true }),
  exit: () => set({ inFocusMode: false })
}))
